import { atom, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { AssignTemplateFieldTypes } from '../../../../../schemas/template-assignment-schema';
import { selectedKpiCompaniesStateDCJ } from '../AllCompaniesStateJ';
import { getCompanySyncIfResolved } from '../../../../../services/state/CompanyStateJ';
import { ICompanyDataModel } from '../../../../../data-models/company.data-model';

export const templateAssignmentFormStateJ = atom<Partial<AssignTemplateFieldTypes> | null>(null);

export const currentFormCompanyDataStateJ = atom<Map<number, ICompanyDataModel>>((get) => {
  const selected = get(selectedKpiCompaniesStateDCJ);
  const map = new Map<number, ICompanyDataModel>();
  for (const company of selected) {
    const data = getCompanySyncIfResolved(company.id);
    if (data) {
      map.set(company.id, data);
    }
  }
  return map;
});

/**
 * Current step (zero-indexed) for the multi-step template-assignment form.
 *
 * Originally migrated in PR 9e when `StepperFormButtons` was switched to
 * accept `PrimitiveAtom<number>`. Stays here alongside the rest of the
 * form state, now also Jotai-native after PR 12b.
 */
export const currentStepStateTAJ = atom<number>(0);

export function useResetTemplateAssignmentFormState() {
  const resetFormState = useSetAtom(templateAssignmentFormStateJ);
  const setCurrentStep = useSetAtom(currentStepStateTAJ);

  return useCallback(() => {
    resetFormState(null);
    setCurrentStep(0);
  }, [resetFormState, setCurrentStep]);
}
